// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/erste-dietz-umweltwoche/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const ersteDietzUmweltwocheDE: PageEntry = {
  id: "post.erste-dietz-umweltwoche",
  locale: "de",
  slug: "erste-dietz-umweltwoche",
  seo: {
    title: "Erste Dietz Umweltwoche | Dietz GmbH",
    description: "Erste Dietz Umweltwoche",
  },
  type: "post",
  h1: "Erste Dietz Umweltwoche",
  blocks: [
    { kind: "heading", level: 2, text: "Erste Dietz Umweltwoche" },
    { kind: "paragraph", text: "„Umweltbewusstsein leben und mit Ideen gemeinsam voranbringen“ – Unter diesem Motto stand diese Woche die erste Dietz Umweltwoche." },
    { kind: "paragraph", text: "Unsere Mitarbeiterinnen und Mitarbeiter erhielten einen Einblick in unterschiedliche Themenbereiche und sammelten fleißig Verbesserungsvorschläge. Die Themengebiete erstreckten sich von Energiemanagement bis hin zu Abfallmanagement. Unter anderem ging es um eine Neugestaltung unserer Außenanlagen mit heimischen Pflanzenarten." },
    { kind: "paragraph", text: "Herzlichen Dank möchten wir an die fachkundige Unterstützung vom Bund Naturschutz Coburg und der Ökologischen Bildungsstätte Oberfranken sagen." },
    { kind: "paragraph", text: "Wir freuen uns Dank dieser Ideen wieder ein Stück weiter zu kommen und der Biodiversität bei uns einen Platz zur Entfaltung zu geben." },
    { kind: "paragraph", text: "Unser großes Ziel ist es Teil eines Umweltprojektes zu werden." },
    { kind: "paragraph", text: "Sie haben Ideen hierzu und möchten uns gerne bei diesem ehrgeizigen Projekt unterstützen? Dann melden Sie sich gerne bis Ende April 2022 bei uns." }
  ],
};
